export const APPLICATION_STAGES = {
  // Initial Stages
  PENDING: {
    key: 'pending',
    label: 'Pending Review',
    description: 'New application awaiting initial review'
  },
  INFO_REQUESTED: {
    key: 'info_requested',
    label: 'Information Requested',
    description: 'Waiting for additional information from applicant'
  },
  LEGAL_REVIEW: {
    key: 'legal_review',
    label: 'Legal Review',
    description: 'Under legal review'
  },
  
  // Decision Stages
  DENIED: {
    key: 'denied',
    label: 'Denied',
    description: 'Application has been denied'
  },
  
  // Approval Pipeline Stages
  APPROVED: {
    key: 'approved',
    label: 'Approved',
    description: 'Application approved, awaiting intro meeting scheduling'
  },
  MEETING_SCHEDULED: {
    key: 'meeting_scheduled',
    label: 'Meeting Scheduled',
    description: 'Intro meeting has been scheduled'
  },
  MEETING_COMPLETED: {
    key: 'meeting_completed',
    label: 'Meeting Completed',
    description: 'Intro meeting completed'
  },
  CONTRACT_REVIEW: {
    key: 'contract_review',
    label: 'Contract Review',
    description: 'Agreement sent for review'
  },
  COMPLETED: {
    key: 'completed',
    label: 'Won',
    description: 'Agreement signed and completed'
  }
};

export const STAGE_TRANSITIONS = {
  [APPLICATION_STAGES.PENDING.key]: [
    APPLICATION_STAGES.INFO_REQUESTED.key,
    APPLICATION_STAGES.LEGAL_REVIEW.key,
    APPLICATION_STAGES.APPROVED.key,
    APPLICATION_STAGES.DENIED.key
  ],
  [APPLICATION_STAGES.INFO_REQUESTED.key]: [
    APPLICATION_STAGES.PENDING.key,
    APPLICATION_STAGES.LEGAL_REVIEW.key,
    APPLICATION_STAGES.APPROVED.key,
    APPLICATION_STAGES.DENIED.key
  ],
  // ... define valid transitions for each stage
};

export const getStageColor = (stage) => {
  switch (stage) {
    case APPLICATION_STAGES.PENDING.key:
      return '#3498db';
    case APPLICATION_STAGES.INFO_REQUESTED.key:
      return '#9b59b6';
    case APPLICATION_STAGES.LEGAL_REVIEW.key:
      return '#f1c40f';
    case APPLICATION_STAGES.DENIED.key:
      return '#e74c3c';
    case APPLICATION_STAGES.APPROVED.key:
      return '#2ecc71';
    case APPLICATION_STAGES.MEETING_SCHEDULED.key:
      return '#27ae60';
    case APPLICATION_STAGES.MEETING_COMPLETED.key:
      return '#16a085';
    case APPLICATION_STAGES.CONTRACT_REVIEW.key:
      return '#2980b9';
    case APPLICATION_STAGES.COMPLETED.key:
      return '#27ae60';
    default:
      return '#95a5a6';
  }
};

export const updateApplicationStage = async (applicationId, newStage, metadata = {}) => {
  try {
    const response = await fetch(`/api/applications/${applicationId}/stage`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        stage: newStage,
        metadata: {
          ...metadata,
          timestamp: new Date().toISOString(),
        }
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to update application stage');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating application stage:', error);
    throw error;
  }
};

export default {
  APPLICATION_STAGES,
  STAGE_TRANSITIONS,
  getStageColor,
  updateApplicationStage
}; 